export default "7c3fafab09e77f32.png"